import React, {Component} from 'react';
import {connect} from 'react-redux';
import Action from 'actions';
import Const from 'constants';
import Tooltip from 'components/atoms/tooltip';
import SimpleSelect from 'components/atoms/dropdowns/simple-select';

class SelectOpposingPlayers extends Component {
    onChangeOpposingPlayers(value) {
        this.props.dispatch(Action.set('OpposingPlayers', value));
    }

    render() {
        const {lineupsFilter, sportConfig} = this.props;
        const opposingPlayersCount = sportConfig.getConfigProp('opposingPlayersCount');

        if (opposingPlayersCount <= 0) {
            return null;
        }

        let defaultOptions = {0: '0 Players'};
        let options = Object.assign(
            defaultOptions,
            Const.EXTRA_OPPOSING_SETTINGS[sportConfig.getGameType()][sportConfig.getSport()],
        );

        for (let i = 1; i <= opposingPlayersCount; i++) {
            options[i] = 'max ' + i + ' Player';
        }

        return (
            <div className="input-info">
                <Tooltip subject="Number of Players Allowed Facing the Defense Used In the Lineup." />
                <SimpleSelect
                    key={lineupsFilter.opposingPlayers}
                    value={lineupsFilter.opposingPlayers}
                    options={options}
                    onChange={::this.onChangeOpposingPlayers}
                    testId="players-vs-defense-number-dropdown"
                    optionTestId="players-vs-defense-option"
                />
            </div>
        );
    }
}

function mapStatesToProps(state) {
    const {sportConfig} = state;
    const {filters: lineupsFilter} = state.lineupsData;

    return {
        lineupsFilter,
        sportConfig,
    };
}

export default connect(mapStatesToProps)(SelectOpposingPlayers);
